export enum TipoPermissao {
  VISUALIZAR = "VISUALIZAR",
  INCLUIR = "INCLUIR",
  ALTERAR = "ALTERAR",
  EXCLUIR = "EXCLUIR",
  EXECUTAR = "EXECUTAR",
}
